import { __decorate } from "tslib";
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import HelixElement from '../../shared/types/helix-element.js';
import { localized } from '@lit/localize';
import { iconLibrary } from './icon-library.js';
let HlxIcon = class HlxIcon extends HelixElement {
    constructor() {
        super(...arguments);
        this.fill = 'currentColor';
        this.size = 16;
        this.title = '';
        this.decorative = false;
    }
    static get styles() {
        return [
            css `
                :host {
                    display: inline-flex;
                }
            `,
        ];
    }
    render() {
        const innerSvg = this.getIcon();
        const id = crypto.randomUUID();
        return html `
            <svg
                xmlns="http://www.w3.org/2000/svg"
                part="icon-base"
                width="${this.size}"
                height="${this.size}"
                fill="${this.fill}"
                viewBox="0 0 16 16"
                role="img"
                aria-hidden="${this.decorative ? 'true' : 'false'}"
                aria-labelledby="${id}">
                ${this.title ?
            html `
                        <title id="${id}">${this.title}</title>
                    `
            : nothing}
                ${innerSvg ?
            html `
                        ${unsafeSVG(innerSvg)}
                    `
            : nothing}
            </svg>
        `;
    }
    getIcon() {
        if (this.name in iconLibrary) {
            return iconLibrary[this.name];
        }
        else {
            return '';
        }
    }
};
__decorate([
    property({ type: String, reflect: true })
], HlxIcon.prototype, "name", void 0);
__decorate([
    property({ type: String })
], HlxIcon.prototype, "fill", void 0);
__decorate([
    property({ type: Number, reflect: true })
], HlxIcon.prototype, "size", void 0);
__decorate([
    property({ type: String })
], HlxIcon.prototype, "title", void 0);
__decorate([
    property({ type: Boolean })
], HlxIcon.prototype, "decorative", void 0);
HlxIcon = __decorate([
    customElement('hlx-icon'),
    localized()
], HlxIcon);
export { HlxIcon };
//# sourceMappingURL=icon.js.map